import type React from 'react';

import { Button, Image, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import type { LandingPageSlug } from '#src/app/pages/landing/template/pageContext';
import facesLeftCambiemoscolombia from '#src/app/pages/landing/template/shared/assets/faces-left-cambiemoscolombia.webp';
import facesLeft from '#src/app/pages/landing/template/shared/assets/faces-left.webp';
import facesMobileCambiemoscolombia from '#src/app/pages/landing/template/shared/assets/faces-mobile-cambiemoscolombia.webp';
import facesMobile from '#src/app/pages/landing/template/shared/assets/faces-mobile.webp';
import facesRightCambiemoscolombia from '#src/app/pages/landing/template/shared/assets/faces-right-cambiemoscolombia.webp';
import facesRight from '#src/app/pages/landing/template/shared/assets/faces-right.webp';

type Props = {
	slug: LandingPageSlug;
	onCtaClick: () => void;
};

const FACES_BY_SLUG: Record<LandingPageSlug, { left: string; right: string; mobile: string }> = {
	'start-a-local-school-reform-petition': { left: facesLeft, right: facesRight, mobile: facesMobile },
	'start-an-education-reform-petition': { left: facesLeft, right: facesRight, mobile: facesMobile },
	'start-a-healthcare-reform-petition': { left: facesLeft, right: facesRight, mobile: facesMobile },
	'start-a-local-municipal-reform-petition': { left: facesLeft, right: facesRight, mobile: facesMobile },
	'how-to-start-a-petition': { left: facesLeft, right: facesRight, mobile: facesMobile },
	cambiemoscolombia: {
		left: facesLeftCambiemoscolombia,
		right: facesRightCambiemoscolombia,
		mobile: facesMobileCambiemoscolombia,
	},
};

export const FooterCta: React.FC<Props> = ({ onCtaClick, slug }) => {
	const faces = FACES_BY_SLUG[slug];

	return (
		<div className="p-10">
			<div className="block md:hidden">
				<Image className="aspect-auto py-8" alt="" src={faces.mobile} />
			</div>
			<div className="my-8 flex items-center justify-center">
				<div className="hidden md:inline">
					<Image className="aspect-auto max-w-[300px] p-4" alt="" src={faces.left} />
				</div>
				<div className="flex-1 px-0 md:px-4">
					<Text as="p" size="x-large" fontWeight="bold" className="text-typography-brand mb-4 text-center">
						<Translate value={`landing.${slug}.footer_cta.title`} />
					</Text>
					<Text as="p" className="text-center">
						<Translate value={`landing.${slug}.footer_cta.body`} />
					</Text>
					<div className="mt-8 flex items-center justify-center">
						<Button
							as="a"
							href={`/start-a-petition/intro?source_location=${slug}_landing_page`}
							onClick={onCtaClick}
							variant="primary"
							className="w-[300px]"
						>
							<Translate value={`landing.${slug}.footer_cta.button`} />
						</Button>
					</div>
				</div>
				<div className="hidden md:inline">
					<Image className="aspect-auto max-w-[300px] p-4" alt="" src={faces.right} />
				</div>
			</div>
		</div>
	);
};
